<template>
  <article>
    <header class="mb-5 flex items-start gap-4">
      <div
        class="grid size-10 place-items-center rounded-xl bg-gradient-to-br from-sky-500 to-indigo-500 text-white shadow-md ring-8 ring-sky-50/60"
      >
        💡
      </div>
      <h2 class="text-2xl font-semibold leading-snug tracking-tight text-slate-900">
        Sprawdź cenę swojej strony — w kilka klików
      </h2>
    </header>

    <p class="text-slate-600">
      Nasz kalkulator cenowy to szybki i prosty sposób, aby dowiedzieć się, ile będzie
      kosztować stworzenie Twojej strony internetowej.
    </p>

    <ul class="mt-6 space-y-3">
      <li class="flex gap-3">
        <span class="mt-1">📋</span>
        <p class="text-slate-700">
          Odpowiedz na kilka krótkich pytań (np. ile podstron potrzebujesz, czy chcesz
          sklep, blog, itd.)
        </p>
      </li>
      <li class="flex gap-3">
        <span class="mt-1">💰</span>
        <p class="text-slate-700">
          Otrzymasz wstępną wycenę dostosowaną do Twoich potrzeb — bez żadnych zobowiązań
        </p>
      </li>
      <li class="flex gap-3">
        <span class="mt-1">⚡</span>
        <p class="text-slate-700">
          To trwa mniej niż 2 minuty i nie wymaga żadnych danych kontaktowych
        </p>
      </li>
    </ul>

    <p class="mt-6 text-slate-600">
      Dzięki temu z góry wiesz, na co się przygotować i ile będzie kosztować projekt
      dopasowany dokładnie do Ciebie.
    </p>

    <p class="mt-3 text-sm text-slate-500">
      Sprawdź sam i zobacz, że stworzenie profesjonalnej strony może być prostsze, niż
      myślisz.
    </p>
  </article>
</template>
